// src/components/Loader.js
import React from 'react';
import './Loader.css'; // Add styling for the loader

const Loader = () => {
  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
